export default __webpack_public_path__ + "static/placeholder-team-member-dfd2b8424f6509d45eca4f975ea3ff41.jpg";